(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1379],{

/***/ 34140:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ BrokerQuickLinks; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71230);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15746);
/* harmony import */ var _shared_QuickLinks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87160);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);





var renderable = function renderable(broker) {
  var commodityTrading = broker.commodity_trading;
  var currencyTrading = broker.currency_trading;
  var accountOpeningProcess = broker.account_opening_process;
  var demat = broker.demat,
      exposure = broker.exposure; // If any of the option is availble then quickLInks are renderable
  // commodityTrading(For now only) || Otheroption || Another Option

  return commodityTrading || currencyTrading || accountOpeningProcess || demat || exposure;
};

function BrokerQuickLinks(_ref) {
  var broker = _ref.broker,
      RenderReview = _ref.RenderReview,
      currentPage = _ref.currentPage;
  if (!broker) return null;
  var name = broker.name,
      slug = broker.slug,
      commodityTrading = broker.commodity_trading,
      currencyTrading = broker.currency_trading,
      accountOpeningProcess = broker.account_opening_process,
      demat = broker.demat,
      exposure = broker.exposure;
  var title = '';
  var linkList = [];

  if (RenderReview || renderable(broker)) {
    title = 'Quick Links';

    if (RenderReview) {
      linkList.push({
        href: '/broker/[slug]/',
        as: "/broker/".concat(slug, "/"),
        linkText: " ".concat(name, " Review")
      });
    }

    if (accountOpeningProcess && currentPage !== 'AccountOpening') {
      linkList.push({
        href: '/broker/[slug]/account-opening-process',
        as: "/broker/".concat(slug, "/account-opening-process"),
        linkText: " ".concat(name, " Account Opening Process")
      });
    }

    if (commodityTrading && currentPage !== 'CommodityTrading') {
      linkList.push({
        href: '/broker/[slug]/commodity-trading',
        as: "/broker/".concat(slug, "/commodity-trading"),
        linkText: " ".concat(name, " Commodity Trading")
      });
    }

    if (currencyTrading && currentPage !== 'currencyTrading') {
      linkList.push({
        href: '/broker/[slug]/currency-trading',
        as: "/broker/".concat(slug, "/currency-trading"),
        linkText: " ".concat(name, " Currency Trading")
      });
    }

    if (demat && currentPage !== 'dematAccountReviewChargesOpening') {
      linkList.push({
        href: '/broker/[slug]/demat-account-review-charges-opening',
        as: "/broker/".concat(slug, "/demat-account-review-charges-opening"),
        linkText: " ".concat(name, " Demat account review")
      });
    }

    if (exposure && currentPage !== 'margin-exposure-leverage') {
      linkList.push({
        href: '/broker/[slug]/margin-exposure-leverage',
        as: "/broker/".concat(slug, "/margin-exposure-leverage"),
        linkText: " ".concat(name, " Exposure")
      });
    }

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        span: 24,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_shared_QuickLinks__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
          title: title,
          linkList: linkList
        })
      })
    });
  }

  return null;
}
BrokerQuickLinks.defaultProps = {
  RenderReview: false,
  currentPage: 'broker'
};

/***/ }),

/***/ 37610:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CommodityBrokerage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _shared_FOBrokerage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92726);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);



function CommodityBrokerage(_ref) {
  var broker = _ref.broker;
  var commodity_futures_brokerage = broker.commodity_futures_brokerage,
      commodity_options_brokerage = broker.commodity_options_brokerage;
  if (!commodity_futures_brokerage) return null;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_shared_FOBrokerage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    broker: broker,
    foType: "Commodity",
    futures_brokerage: commodity_futures_brokerage,
    options_brokerage: commodity_options_brokerage
  });
}

/***/ }),

/***/ 69089:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CommodityTrading; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38456);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_markdown__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51945);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71230);
/* harmony import */ var _shared_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50145);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);









var CalculatedContent = function CalculatedContent(truncate, slug, commodityTrading) {
  if (truncate) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((react_markdown__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: commodityTrading.split(' ', _shared_constants__WEBPACK_IMPORTED_MODULE_4__/* .IntroLimit */ .hS).join(' ')
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        style: {
          width: '100%',
          textAlign: 'right'
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
          href: "/broker/[slug]/commodity-trading",
          as: "/broker/".concat(slug, "/commodity-trading"),
          children: "... Read More"
        })
      })]
    });
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((react_markdown__WEBPACK_IMPORTED_MODULE_1___default()), {
    children: commodityTrading
  });
};

function CommodityTrading(_ref) {
  var broker = _ref.broker,
      truncate = _ref.truncate,
      title = _ref.title;
  var Title = antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Title */ .Z.Title;
  var name = broker.name,
      slug = broker.slug,
      commodityTrading = broker.commodity_trading;
  if (!commodityTrading) return null;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
    children: [title ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(Title, {
      level: 2,
      className: "title-wrapper",
      children: ["".concat(name, " "), "Commodity Trading"]
    }) : null, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
      className: "row-wrapper",
      children: CalculatedContent(truncate, slug, commodityTrading)
    })]
  });
}
CommodityTrading.defaultProps = {
  truncate: false,
  title: false
};

/***/ }),

/***/ 92726:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FOBrokerage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51945);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97565);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);





var columns = function columns(foType) {
  return [{
    title: 'Charge',
    dataIndex: 'charge',
    render: function render(text) {
      return text;
    }
  }, {
    title: "".concat(foType, " Futures"),
    className: 'column-money',
    dataIndex: 'futures',
    align: 'right'
  }, {
    title: "".concat(foType, " Options"),
    className: 'column-money',
    dataIndex: 'options',
    align: 'right'
  }];
};

var keyNameMap = {
  brokerage: 'Brokerage',
  stt: 'Securities Transaction Tax (STT)',
  turnover: 'Transaction / Turnover Charges',
  gst: 'Goods and Services Tax (GST)',
  sebi: 'SEBI Charges',
  stamp: 'Stamp Charges'
};
function FOBrokerage(_ref) {
  var broker = _ref.broker,
      foType = _ref.foType,
      futures_brokerage = _ref.futures_brokerage,
      options_brokerage = _ref.options_brokerage;
  var Title = antd__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Title */ .Z.Title;
  var name = broker.name;
  if (!futures_brokerage) return null;
  var data = Object.keys(futures_brokerage).filter(function (k) {
    return k !== '__typename';
  }).map(function (k) {
    return {
      key: k,
      charge: keyNameMap[k],
      futures: futures_brokerage[k],
      options: options_brokerage[k]
    };
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    columns: columns(foType),
    dataSource: data,
    bordered: true,
    title: function title() {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Title, {
        level: 2,
        children: [name, " ", foType, " F&O Brokerage: ", new Date().getFullYear()]
      });
    },
    pagination: false
  });
}

/***/ }),

/***/ 54242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ArticleList; }
/* harmony export */ });
/* harmony import */ var _home_circleci_project_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(71383);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15045);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51945);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71230);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(15746);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(12922);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38456);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_markdown__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _shared_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50145);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


var _templateObject;









var Panel = antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Panel */ .Z.Panel;
var Title = antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Title */ .Z.Title;

var ArticleLink = function ArticleLink(_ref) {
  var slug = _ref.slug,
      text = _ref.text;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
    href: "/article/[slug]",
    as: "/article/".concat(slug),
    className: "ant-anchor-link-title ant-anchor-link-title-active",
    children: text
  });
};

var customTitle = function customTitle(title, slug) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Title, {
    level: 4,
    style: {
      margin: '0px'
    },
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(ArticleLink, {
      slug: slug,
      text: title
    })
  });
};

var HeaderTitle = function HeaderTitle() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Title, {
    level: 3,
    style: {
      margin: '0px'
    },
    children: "Frequently Asked Questions or FAQs"
  });
};

var articleCollaps = function articleCollaps(article, index) {
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var _article$attributes = article.attributes,
      title = _article$attributes.title,
      slug = _article$attributes.slug,
      shortDescription = _article$attributes.short_description,
      description = _article$attributes.description;
  var wordLimit = type === 'softwares' ? _shared_constants__WEBPACK_IMPORTED_MODULE_6__/* .SOFTWARE_FAQ_DESCRIPTION_LIMIT */ .IC : _shared_constants__WEBPACK_IMPORTED_MODULE_6__/* .FAQ_DESCRIPTION_LIMIT */ .IO;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(Panel, {
    header: customTitle(title, slug),
    className: "pannelCon",
    showArrow: false,
    disabled: true,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((react_markdown__WEBPACK_IMPORTED_MODULE_1___default()), {
      children: (shortDescription || description).split(' ', wordLimit).join(' ')
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
      style: {
        width: '100%',
        textAlign: 'right'
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(ArticleLink, {
        slug: slug,
        text: ".. Read More"
      })
    })]
  }, index);
};

var CollapseHeader = function CollapseHeader() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Panel, {
    header: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(HeaderTitle, {}),
    className: "pannelCon",
    showArrow: false,
    disabled: true
  }, "header");
};

function ArticleList(_ref2) {
  var articles = _ref2.articles,
      _ref2$type = _ref2.type,
      type = _ref2$type === void 0 ? null : _ref2$type;

  if (articles.length === 0) {
    return null;
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
    className: "page-wrapper",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(antd__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
      span: 24,
      style: {
        fontWeight: 'normal',
        fontSize: '16px',
        lineHeight: '22px'
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        bordered: false,
        defaultActiveKey: articles.map(function (_, index) {
          return index;
        }),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(CollapseHeader, {}), articles.map(function (article, index) {
          return articleCollaps(article, index, type);
        })]
      })
    })
  });
}
ArticleList.fragments = {
  articles: (0,_apollo_client__WEBPACK_IMPORTED_MODULE_9__/* .gql */ .Ps)(_templateObject || (_templateObject = (0,_home_circleci_project_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(["\n    fragment Articles on Article {\n      slug\n      title\n      short_description\n      description\n    }\n  "])))
};

/***/ }),

/***/ 87160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ QuickLinks; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38456);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_markdown__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(87547);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(88641);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71230);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15746);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3679);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);










var titleFormat = function titleFormat(linkTitle, icon) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
    children: [icon, " ".concat(linkTitle)]
  });
};

function QuickLinks(props) {
  var icon = props.icon,
      title = props.title,
      linkList = props.linkList,
      country = props.country;
  if (linkList < 1 || linkList === 'undefined') return null;
  return linkList ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
    children: [country === 'India' && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
      style: {
        paddingBottom: '32px'
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        style: {
          minWidth: '250px'
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
          target: "_blank",
          href: "https://bit.ly/2YUNebF",
          rel: "noreferrer",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
            width: 252,
            height: 302,
            alt: "",
            "data-src": "https://assets.fintrakk.com/Zerodha-Banner-252x302.png",
            src: "https://assets.fintrakk.com/Zerodha-Banner-252x302.png"
          })
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z // eslint-disable-next-line prettier/prettier
    , {
      title: titleFormat(title, icon),
      size: "small",
      bordered: false,
      style: {
        // float: 'right',
        boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.15)',
        borderRadius: '2px',
        minWidth: '100%',
        marginBottom: '16px'
      },
      headStyle: {
        background: '#E6F7FF',
        padding: '5px 0px 0px 25px'
      },
      bodyStyle: {
        padding: '15px 20px 0px 25px',
        minWidth: '272px'
      },
      children: linkList.map(function (qlink, i) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
          style: {
            marginBottom: '1em'
          },
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
            href: qlink.href,
            as: qlink.as,
            children: qlink.linkText
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("br", {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
            style: {
              fontSize: '10px'
            },
            children: qlink.textDescription !== 'null' ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_markdown__WEBPACK_IMPORTED_MODULE_1___default()), {
              children: qlink.textDescription
            }) : null
          })]
        }, i);
      })
    })]
  }) : null;
}
QuickLinks.defaultProps = {
  icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
};

/***/ }),

/***/ 28262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ ArticleJsonLd; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_stripMarkdown__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22701);
/* harmony import */ var shared_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77713);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);




var ArticleJsonLd = function ArticleJsonLd(_ref) {
  var keyOverride = _ref.keyOverride,
      url = _ref.url,
      title = _ref.title,
      _ref$images = _ref.images,
      images = _ref$images === void 0 ? [] : _ref$images,
      _ref$authorName = _ref.authorName,
      authorName = _ref$authorName === void 0 ? 'Fintrakk Admin' : _ref$authorName,
      description = _ref.description,
      _ref$publisherName = _ref.publisherName,
      publisherName = _ref$publisherName === void 0 ? 'Fintrakk' : _ref$publisherName;
  var jsonld = "{\n    \"@context\": \"https://schema.org\",\n    \"@type\": \"Article\",\n    \"mainEntityOfPage\": {\n      \"@type\": \"WebPage\",\n      \"@id\": \"".concat(url, "\"\n    },\n    \"headline\": \"").concat(title, "\",\n    \"image\": [\n      ").concat(images.map(function (image) {
    return "\"".concat(image, "\"");
  }), "\n     ],\n    \"author\": \"").concat(authorName, "\",\n    \"publisher\": {\n      \"@type\": \"Organization\",\n      \"name\": \"").concat(publisherName, "\",\n      \"logo\": {\n        \"@type\": \"ImageObject\",\n        \"url\": \"").concat(shared_util__WEBPACK_IMPORTED_MODULE_2__/* .logoUrl */ .P6, "\"\n      }\n    },\n    \"description\": ").concat((0,_utils_stripMarkdown__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(description), "\n  }");
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: jsonld
    }
  }, "jsonld-article".concat(keyOverride ? "-".concat(keyOverride) : ''));
};

/***/ }),

/***/ 22701:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ stripMarkdown; }
/* harmony export */ });
/* harmony import */ var remove_markdown__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26525);
/* harmony import */ var remove_markdown__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(remove_markdown__WEBPACK_IMPORTED_MODULE_0__);

function stripMarkdown(text) {
  return JSON.stringify(remove_markdown__WEBPACK_IMPORTED_MODULE_0___default()(text));
}

/***/ }),

/***/ 75695:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ Broker; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/antd/es/typography/index.js + 20 modules
var typography = __webpack_require__(51945);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./components/broker/BrokerQuickLinks.js
var BrokerQuickLinks = __webpack_require__(34140);
// EXTERNAL MODULE: ./components/broker/CommodityBrokerage.js
var CommodityBrokerage = __webpack_require__(37610);
// EXTERNAL MODULE: ./components/broker/CommodityTrading.tsx
var CommodityTrading = __webpack_require__(69089);
// EXTERNAL MODULE: ./components/shared/ArticleList.tsx
var ArticleList = __webpack_require__(54242);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/broker/commodity-trading/index.js









var header = function header(_ref) {
  var broker = _ref.broker;
  return "".concat(broker.name, ": Commodity Trading: Brokerage, Charges, Reviews: ").concat(new Date().getFullYear());
};

function CommodityTradingMain(_ref2) {
  var broker = _ref2.broker,
      articles = _ref2.articles;
  var Title = typography/* default.Title */.Z.Title;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(row/* default */.Z, {
    className: "page-wrapper page",
    gutter: [16, 16],
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
      className: "title-wrapper",
      style: {
        width: '100%'
      },
      children: header({
        broker: broker
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(col/* default */.Z, {
      xs: 24,
      md: 16,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CommodityTrading/* default */.Z, {
        broker: broker
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(CommodityBrokerage/* default */.Z, {
        broker: broker
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ArticleList/* default */.Z, {
        articles: articles
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
      xs: 24,
      md: 8,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(BrokerQuickLinks/* default */.Z, {
        broker: broker,
        RenderReview: true,
        currentPage: "CommodityTrading"
      })
    })]
  });
}
// EXTERNAL MODULE: ./components/shared/schema/article.tsx
var article = __webpack_require__(28262);
// EXTERNAL MODULE: ./layouts/application.tsx + 4 modules
var application = __webpack_require__(8182);
// EXTERNAL MODULE: ./shared/util.tsx + 6 modules
var util = __webpack_require__(77713);
;// CONCATENATED MODULE: ./pages/broker/[slug]/commodity-trading.tsx










var title = function title(_ref) {
  var broker = _ref.broker;
  return " ".concat(broker.name, " Commodity Trading: charges, brokerage, details");
};

var description = function description(_ref2) {
  var broker = _ref2.broker;
  return "".concat(broker.name, " commodity trading brokerage, charges, details. How to do commodity trading in  ").concat(broker.name);
};

var __N_SSP = true;
function Broker(props) {
  var router = (0,next_router.useRouter)();
  var asPath = router.asPath;
  var pageData = props.data;
  var brokers = pageData.brokers,
      allBrokers = pageData.all_brokers.data,
      navCalculators = pageData.nav_calculators.data,
      allPages = pageData.all_pages.data;
  var broker = brokers.data[0].attributes;
  var articles = broker.articles.data;
  var pageTitle = title({
    broker: broker
  });
  var pageDescription = description({
    broker: broker
  });
  var country = {
    attributes: {
      name: broker.country.name
    }
  };
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(application/* default */.Z, {
    allBrokers: allBrokers,
    navCalculators: navCalculators,
    allPages: allPages,
    country: country,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: pageTitle
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: pageDescription
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(article/* ArticleJsonLd */.d, {
      url: (0,util/* pageUri */.TI)(asPath),
      title: pageTitle,
      description: pageDescription
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CommodityTradingMain, {
      broker: broker,
      articles: articles
    })]
  });
}

/***/ }),

/***/ 50145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Au": function() { return /* binding */ SITEMAP_PAGE_SIZE_FOR_PAGINATION; },
/* harmony export */   "IC": function() { return /* binding */ SOFTWARE_FAQ_DESCRIPTION_LIMIT; },
/* harmony export */   "IO": function() { return /* binding */ FAQ_DESCRIPTION_LIMIT; },
/* harmony export */   "hS": function() { return /* binding */ IntroLimit; },
/* harmony export */   "t9": function() { return /* binding */ PAGE_SIZE_FOR_PAGINATION; },
/* harmony export */   "up": function() { return /* binding */ DESCRIPTION_LIMIT; }
/* harmony export */ });
var IntroLimit = 50;
var FAQ_DESCRIPTION_LIMIT = 100;
var SOFTWARE_FAQ_DESCRIPTION_LIMIT = 50;
var DESCRIPTION_LIMIT = 100;
var PAGE_SIZE_FOR_PAGINATION = 20;
var SITEMAP_PAGE_SIZE_FOR_PAGINATION = 300;

/***/ }),

/***/ 24564:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/broker/[slug]/commodity-trading",
      function () {
        return __webpack_require__(75695);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5407,2453,3229,7752,2913,1945,2682,7527,6873,3679,5045,2841,7565,1545,8182,9774,2888,179], function() { return __webpack_exec__(24564); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);